import { invoke } from '@shared/easyfy.decorators';
import { GetReceiptErrorPage } from '../services/receipt.service';

@invoke
export default class PageRender {
  private _container: HTMLElement;
  constructor(container: HTMLElement) {
    this._container = container;
  }

  ReplaceContent(data: string, type: string = 'append', clearData: boolean = true) {
    if (clearData) this._container.innerHTML = '';

    const content = document.createRange().createContextualFragment(data).firstElementChild;

    if (type === 'after') {
      this._container.after(content);
      return;
    }

    if (type === 'append' || type === '') {
      this._container.appendChild(content);
    }
  }

  Render(data: any): void {
    try {
      if (data?.partialHtml) this.ReplaceContent(data?.partialHtml);

      if (data?.orderSummary) {
        // clear all the html content
        this.ClearContent(this._container);

        if (data?.orderSummary?.paymentSummary) this.ReplaceContent(data?.orderSummary?.paymentSummary, 'append', false);

        if (data?.orderSummary?.orderProductSummary) this.ReplaceContent(data?.orderSummary?.orderProductSummary, 'append', false);

        if (data?.orderSummary?.orderJourney) this.ReplaceContent(data?.orderSummary?.orderJourney, 'append', false);

        if (data?.orderSummary?.trustedShopsData) this.ShowTrustedPopup(data?.orderSummary?.trustedShopsData);

        // enable links
        this.SwitchLogoElement();
      }

      if (!data?.partialHtml && !data?.orderSummary) {
        this.RenderAgeVerificationError();
      }
    } catch (error) {
      this.RenderDefaultError();
    }
  }

  ShowTrustedPopup(htmlString: string) {
    // Create a TrustedShops and content containers
    const modal = document.createElement('div');
    const content = document.createElement('div');

    // Parse the TrustedShops HTML string
    const tempDiv = document.createElement('div');
    tempDiv.classList.add('trusted-shops-container');
    tempDiv.innerHTML = htmlString;

    // Extract the TrustedShops <script> separately so it executes
    const script = tempDiv.querySelector('script');
    if (script) {
      const newScript = document.createElement('script');

      Array.from(script.attributes).forEach((attr) => {
        newScript.setAttribute(attr.name, attr.value);
      });

      document.body.appendChild(newScript);
      script.remove();
    }

    content.appendChild(tempDiv);
    modal.appendChild(content);
    this._container.appendChild(modal);
  }

  SwitchLogoElement() {
    try {
      const logoElement: HTMLElement = document.querySelector('i.site-logo');
      if (logoElement) {
        const logoAnchor = document.createElement('a');
        logoAnchor.href = '/';
        logoAnchor.className = 'site-logo';
        logoElement.replaceWith(logoAnchor);
      }
    } catch (e) {
      console.log(e);
    }
  }

  ClearContent = (container) => (container.innerHTML = '');

  RenderDefaultError = async () => {
    var isAgeVerification = false;
    await this.RenderErrorPage(isAgeVerification);
  };

  RenderAgeVerificationError = async () => {
    var isAgeVerification = true;
    await this.RenderErrorPage(isAgeVerification);
  };

  RenderErrorPage = async (isAgeVerification: boolean) => {
    const response = await GetReceiptErrorPage(isAgeVerification);
    if (response.data?.partialHtml) {
      this.ReplaceContent(response.data?.partialHtml);
    }
  };

  ClearResponseTimeOut(toRequestResponse: any) {
    try {
      clearTimeout(toRequestResponse);
    } catch (err) {
      /* error */
    }
  }
}
